// API service for backend communication

const BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

// Helper function to make API requests
const apiRequest = async (endpoint, options = {}) => {
  const url = `${BASE_URL}${endpoint}`;
  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  };

  try {
    const response = await fetch(url, config);
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error(`API request failed: ${url}`, error);
    throw error;
  }
};

// Batch API functions
export const batchAPI = {
  // Get all batches
  getAll: () => {
    return apiRequest('/batches').then(response => {
      console.log('batchAPI.getAll - received batches:', response);
      if (response && response.length > 0) {
        console.log('batchAPI.getAll - first batch expenditures:', response[0].expenditures);
      }
      return response;
    });
  },
  
  // Get single batch
  getById: (id) => apiRequest(`/batches/${id}`),
  
  // Create new batch
  create: (batchData) => {
    console.log('batchAPI.create - sending data:', batchData);
    console.log('batchAPI.create - expenditures being sent:', batchData.expenditures);
    return apiRequest('/batches', {
      method: 'POST',
      body: JSON.stringify(batchData),
    }).then(response => {
      console.log('batchAPI.create - received response:', response);
      return response;
    });
  },
  
  // Update batch
  update: (id, batchData) => apiRequest(`/batches/${id}`, {
    method: 'PUT',
    body: JSON.stringify(batchData),
  }),
  
  // Delete batch
  delete: (id) => apiRequest(`/batches/${id}`, {
    method: 'DELETE',
  }),
};

// Egg Production API functions
export const eggAPI = {
  // Get all egg production records
  getAll: () => apiRequest('/eggs'),
  
  // Create new egg production record
  create: (eggData) => apiRequest('/eggs', {
    method: 'POST',
    body: JSON.stringify(eggData),
  }),
  
  // Update egg production record
  update: (id, eggData) => apiRequest(`/eggs/${id}`, {
    method: 'PUT',
    body: JSON.stringify(eggData),
  }),
  
  // Delete egg production record
  delete: (id) => apiRequest(`/eggs/${id}`, {
    method: 'DELETE',
  }),
};

// Treatment API functions
export const treatmentAPI = {
  // Get all treatments
  getAll: () => apiRequest('/treatments'),
  
  // Create new treatment
  create: (treatmentData) => apiRequest('/treatments', {
    method: 'POST',
    body: JSON.stringify(treatmentData),
  }),
  
  // Update treatment
  update: (id, treatmentData) => apiRequest(`/treatments/${id}`, {
    method: 'PUT',
    body: JSON.stringify(treatmentData),
  }),
  
  // Delete treatment
  delete: (id) => apiRequest(`/treatments/${id}`, {
    method: 'DELETE',
  }),
};

// Inventory API functions
export const inventoryAPI = {
  // Get all inventory items
  getAll: () => apiRequest('/inventory'),
  
  // Create new inventory item
  create: (inventoryData) => apiRequest('/inventory', {
    method: 'POST',
    body: JSON.stringify(inventoryData),
  }),
  
  // Update inventory item
  update: (id, inventoryData) => apiRequest(`/inventory/${id}`, {
    method: 'PUT',
    body: JSON.stringify(inventoryData),
  }),
  
  // Delete inventory item
  delete: (id) => apiRequest(`/inventory/${id}`, {
    method: 'DELETE',
  }),
};

// Sales API functions
export const salesAPI = {
  // Get all sales
  getAll: () => apiRequest('/sales'),
  
  // Create new sale
  create: (saleData) => apiRequest('/sales', {
    method: 'POST',
    body: JSON.stringify(saleData),
  }),
  
  // Update sale
  update: (id, saleData) => apiRequest(`/sales/${id}`, {
    method: 'PUT',
    body: JSON.stringify(saleData),
  }),
  
  // Delete sale
  delete: (id) => apiRequest(`/sales/${id}`, {
    method: 'DELETE',
  }),
};

// Expenditures API functions
export const expendituresAPI = {
  // Get all expenditures
  getAll: () => apiRequest('/expenditures'),
  
  // Get expenditures for a specific batch
  getByBatch: (batchId) => apiRequest(`/expenditures/batch/${batchId}`),
  
  // Create new expenditure(s)
  create: (expenditureData) => {
    console.log('expendituresAPI.create - sending data:', expenditureData);
    return apiRequest('/expenditures', {
      method: 'POST',
      body: JSON.stringify(expenditureData),
    }).then(response => {
      console.log('expendituresAPI.create - received response:', response);
      return response;
    });
  },
  
  // Update expenditure
  update: (id, expenditureData) => apiRequest(`/expenditures/${id}`, {
    method: 'PUT',
    body: JSON.stringify(expenditureData),
  }),
  
  // Delete expenditure
  delete: (id) => apiRequest(`/expenditures/${id}`, {
    method: 'DELETE',
  }),
};

export default {
  batchAPI,
  eggAPI,
  treatmentAPI,
  inventoryAPI,
  salesAPI,
  expendituresAPI,
};
